/* =====================================================================
   AOF HEADER — runtime
   Combines: announce rotation, mobile drawer, mega hover-intent,
   scroll-state header, search toggle, live cart preview.
   ===================================================================== */
(function () {
  'use strict';

  // Idempotency guard — if this script is ever included more than once on a
  // page, run the runtime only the first time. Without this, a second copy
  // double-binds every listener; the search toggle in particular would fire
  // twice per click (open then immediately close) and appear to do nothing.
  if (window.__aofHeaderInit) return;
  window.__aofHeaderInit = true;

  // ===== Random-subset lists (Explore Brands column, 2026-06-10) =====
  // Liquid renders the FULL list (crawlers see every brand); on each page
  // view we keep a random N (data-random-limit) and drop the rest, so the
  // selection rotates per visit. Shopify Liquid has no random filter and
  // page caching would freeze a server-side shuffle — this is the only
  // per-view randomness available. Display order stays as authored
  // (alphabetical) — only the SELECTION is random.
  (function () {
    var lists = document.querySelectorAll('[data-random-limit]');
    Array.prototype.forEach.call(lists, function (list) {
      var limit = parseInt(list.getAttribute('data-random-limit'), 10);
      var items = Array.prototype.slice.call(list.children);
      if (!limit || items.length <= limit) return;
      var pool = items.slice();
      for (var i = pool.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = pool[i]; pool[i] = pool[j]; pool[j] = t;
      }
      var keep = pool.slice(0, limit);
      items.forEach(function (li) {
        if (keep.indexOf(li) === -1) list.removeChild(li);
      });
    });
  })();

  // ===== Sticky header scroll state + auto-hide on scroll-down =====
  // Two behaviours combined:
  //   1. Toggles `.is-stuck` on the header once past the announcement bar
  //      (CSS adds shadow / border swap so the header reads as detached).
  //   2. Toggles `.is-hidden` on the sticky section when scrolling DOWN past
  //      a hide threshold — the whole header (announcement + nav) slides up
  //      out of view. Any UP scroll reveals it again. Always visible at the
  //      top of the page and while a drawer / menu is open.
  //   END Clothing / MR PORTER / COS pattern — content gets the viewport,
  //   nav is one scroll-up away whenever needed.
  (function () {
    var section = document.querySelector('.shopify-section.section-aof-header');
    var header = document.querySelector('.aof-header');
    var announce = document.querySelector('.aof-announce');
    if (!header || !section) return;

    var stuckThreshold = (announce ? announce.offsetHeight : 40) - 2;
    var hideThreshold = (announce ? announce.offsetHeight : 40) + 60;
    var lastY = window.scrollY;
    var ticking = false;

    function update() {
      var currentY = window.scrollY;
      var delta = currentY - lastY;

      // Stuck = past the announcement bar: adds the elevation shadow AND
      // condenses the header (full → compact) via CSS.
      header.classList.toggle('is-stuck', currentY > stuckThreshold);

      // Auto-hide on scroll DOWN, reveal on scroll UP (END / MR PORTER pattern).
      // Always shown at the top of the page and while the drawer is open.
      var drawerOpen = document.body.classList.contains('aof-no-scroll');
      if (drawerOpen || currentY <= hideThreshold) {
        section.classList.remove('is-hidden');
      } else if (delta > 4) {
        section.classList.add('is-hidden');      // scrolling down — hide
      } else if (delta < -4) {
        section.classList.remove('is-hidden');   // scrolling up — reveal
      }

      lastY = currentY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (announce) {
        stuckThreshold = announce.offsetHeight - 2;
        hideThreshold = announce.offsetHeight + 60;
      }
    });

    update();
  })();

  // ===== Announcement bar rotation =====
  (function () {
    var msgs = document.querySelectorAll('.aof-announce__msg');
    if (msgs.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var idx = 0;
    setInterval(function () {
      msgs[idx].classList.remove('is-active');
      msgs[idx].setAttribute('aria-hidden', 'true');
      idx = (idx + 1) % msgs.length;
      msgs[idx].classList.add('is-active');
      msgs[idx].removeAttribute('aria-hidden');
    }, 10000);
  })();

  // ===== Mobile drawer =====
  (function () {
    var hamburger = document.getElementById('aof-hamburger');
    var drawer = document.getElementById('aof-drawer');
    if (!hamburger || !drawer) return;

    // ⚑ PORTAL THE DRAWER TO <body> — do not remove (fixed 2026-08-06).
    // The drawer is `position: fixed; inset: 0`, but it renders from inside
    // sections/aof-header.liquid, so it sits in `.shopify-section.section-aof-header`
    // — which carries `will-change: transform` AND a real transform on `.is-hidden`.
    // Either one makes that section the CONTAINING BLOCK for a fixed child, so the
    // drawer sized itself to the header: a 72px sliver with the page scroll-locked
    // behind it, on every page below 1200px. Moving it to <body> means no ancestor
    // can ever capture it again — a CSS-only fix would come back the moment anything
    // above it grows a transform. Keeping the render in the header section keeps the
    // menu setting as the single source of truth for what the drawer lists.
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);

    var drawerClose = document.getElementById('aof-drawer-close');
    var lastFocus = null;

    function openDrawer() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('aof-no-scroll');
      requestAnimationFrame(function () { if (drawerClose) drawerClose.focus(); });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('aof-no-scroll');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    hamburger.addEventListener('click', openDrawer);
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    // Hamburger is mobile/tablet only — if the viewport grows past the drawer
    // breakpoint while the drawer is open, close it (the desktop nav takes
    // over). 1200px matches the max-width: 1199px blocks in
    // component-aof-header.css (9-item bar, 2026-06-10).
    var mql = window.matchMedia('(min-width: 1200px)');
    var mqHandler = function (e) {
      if (e.matches && drawer.classList.contains('is-open')) closeDrawer();
    };
    if (mql.addEventListener) mql.addEventListener('change', mqHandler);
    else if (mql.addListener) mql.addListener(mqHandler);
  })();

  // ===== Mega menu hover-intent =====
  (function () {
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (!finePointer.matches) return;

    var OPEN_DELAY = 80;
    var CLOSE_DELAY = 140;
    var openTimer = null;
    var closeTimer = null;
    var openItem = null;

    document.querySelectorAll('.aof-nav__item').forEach(function (item) {
      if (!item.querySelector('.aof-megamenu, .aof-dropdown')) return;

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        if (openItem === item) return;
        openTimer = setTimeout(function () {
          if (openItem && openItem !== item) openItem.classList.remove('is-open');
          item.classList.add('is-open');
          openItem = item;
        }, OPEN_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          item.classList.remove('is-open');
          if (openItem === item) openItem = null;
        }, CLOSE_DELAY);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) {
        var trigger = openItem.querySelector('.aof-nav__link');
        openItem.classList.remove('is-open');
        openItem = null;
        if (trigger) trigger.focus();
      }
    });
  })();

  // ===== Search overlay (icon trigger → full-width drop panel) =====
  (function () {
    var trigger = document.getElementById('aof-search-trigger');
    var overlay = document.getElementById('aof-search-overlay');
    if (!trigger || !overlay) return;
    var input = document.getElementById('aof-search-overlay-input');
    var closeBtn = document.getElementById('aof-search-overlay-close');

    function onDocPointer(e) {
      // Close when clicking/tapping outside the panel and the trigger.
      if (overlay.contains(e.target) || trigger.contains(e.target)) return;
      closeSearch();
    }

    function openSearch() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      if (input) requestAnimationFrame(function () { input.focus(); });
      // capture phase so the close fires before any inner handler swallows it
      document.addEventListener('pointerdown', onDocPointer, true);
    }

    function closeSearch() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('pointerdown', onDocPointer, true);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (overlay.classList.contains('is-open')) closeSearch();
      else openSearch();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeSearch();
        trigger.focus();
      }
    });
  })();

  // ===== Live cart preview =====
  // Server-rendered initial state via Liquid; refresh via /cart.js after mutations.
  (function () {
    var preview = document.querySelector('.aof-cart-preview');
    if (!preview) return;

    var badge = document.querySelector('.aof-cart-badge');
    var cartLink = document.querySelector('.aof-cart-wrap > .aof-icon-btn');
    var countEl = preview.querySelector('.aof-cart-preview__count');
    var itemsEl = preview.querySelector('.aof-cart-preview__items');
    var subtotalEl = preview.querySelector('.aof-cart-preview__subtotal strong');

    var moneyFormat = (window.Shopify && window.Shopify.money_format) || '£{{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      // Quick {{amount}} substitution; theme may set a fuller format
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, value)
                        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
    }

    function thumbHTML(item) {
      var img = item.image || item.featured_image && item.featured_image.url;
      if (img) {
        return '<img class="aof-cart-preview__thumb" src="' + img + '" alt="" loading="lazy">';
      }
      return '<div class="aof-cart-preview__thumb" aria-hidden="true"></div>';
    }

    function escape(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function render(cart) {
      var count = cart.item_count || 0;
      var items = cart.items || [];

      // Badge
      if (badge) {
        if (count > 0) {
          badge.textContent = count;
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }
      if (cartLink) {
        cartLink.setAttribute('aria-label', count === 1 ? 'Cart, 1 item' : 'Cart, ' + count + ' items');
      }

      // Count text
      if (countEl) {
        countEl.textContent = count === 1 ? '1 item' : count + ' items';
      }

      // Items
      if (itemsEl) {
        if (items.length === 0) {
          itemsEl.innerHTML = '<li><p class="aof-cart-preview__empty">Your cart is empty.</p></li>';
        } else {
          // Show first 3
          var visible = items.slice(0, 3);
          itemsEl.innerHTML = visible.map(function (item) {
            return '<li class="aof-cart-preview__item">' +
                   thumbHTML(item) +
                   '<div class="aof-cart-preview__details">' +
                     '<span class="aof-cart-preview__name">' + escape(item.product_title || item.title) + '</span>' +
                     '<span class="aof-cart-preview__meta">' + item.quantity + ' × ' + formatMoney(item.final_price || item.price) + '</span>' +
                   '</div>' +
                   '</li>';
          }).join('');
          if (items.length > visible.length) {
            itemsEl.innerHTML += '<li><p class="aof-cart-preview__empty">+ ' + (items.length - visible.length) + ' more in cart</p></li>';
          }
        }
      }

      // Subtotal
      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(cart.total_price || 0);
      }
    }

    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) render(cart); })
        .catch(function () { /* leave server-rendered state */ });
    }

    // Initial sync (in case of BFCache or stale server-rendered state)
    refresh();

    // Listen for any signal the cart changed. Trade and most modern themes fire
    // 'cart:updated' or use the publish/subscribe pattern. Cover both, and
    // intercept fetch/XHR posts to /cart/add to catch AJAX adds from any source.
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('cart:item-added', refresh);

    // Intercept fetch — refresh after any /cart/add, /cart/change, /cart/update
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var url = (args[0] && args[0].url) || args[0] || '';
        var p = origFetch.apply(this, args);
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { setTimeout(refresh, 100); }).catch(function () {});
        }
        return p;
      };
    }

    // Page show (BFCache) — re-fetch
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refresh();
    });
  })();

})();
